var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-status',{attrs:{"status":_vm.business.status || 'pending'}})}
var staticRenderFns = []

export { render, staticRenderFns }